// Route guard of the Swiper Manager / Swiper Studio pages. The active role
// must have the explicit `create` switch enabled in Animation Settings.
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { canAccessSwiperManager, useSwiperAccess } from "../dynamicSwipers/useSwiperAccess";
import { isAuthenticated } from "./index";
import { signinPathFor } from "./postAuthRedirect";

const SwiperAccessRoute = ({ infoSource, redirectPath = "/your-step", children }) => {
  const location = useLocation();
  const { loading, access } = useSwiperAccess(infoSource);
  if (!isAuthenticated()) return <Navigate to={signinPathFor(location)} replace state={{ from: location }} />;
  if (loading) return <div role="status" aria-busy="true" style={{ minHeight: "40vh" }} />;
  if (!canAccessSwiperManager(access)) {
    return <Navigate to={redirectPath} replace state={{ from: location }} />;
  }
  return children;
};

export default SwiperAccessRoute;
